import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['formElement', 'accountTypeSelect', 'adviceTypeSelect', 'selectionChangedHidden'];

  formElementTarget: HTMLFormElement;

  accountTypeSelectTarget: HTMLSelectElement;

  adviceTypeSelectTarget: HTMLSelectElement;

  selectionChangedHiddenTarget: HTMLInputElement;

  connect(): void {
    this.accountTypeSelectTarget.addEventListener('change', this.accountTypeChanged.bind(this));
  }

  accountTypeChanged(): void {
    this.selectionChangedHiddenTarget.value = 'account_type';

    if (this.adviceTypeSelectTarget) {
      this.adviceTypeSelectTarget.value = 'no_selection';
    }
  }
}
